import React, {useState, useRef, useEffect} from "react";
import GenericButton from "../../../common/buttons/GenericButton";
import {AC_PAGES} from "../../../../constants";
import AcCostItem from "../AcCostItem";
import GenericItem from "../../../common/items/GenericItem";
import BackButton from "../../../common/buttons/BackButton";
import ToggleSwitch from "../../../common/inputs/ToggleSwitch";

const AcPlanDetailsPage = ({ acData, setAcData, product, price, payNow, role, expirationDate, setPage }) => {
    const { doNotRenew } = acData || {};
    const [selectedDoNotRenew, setSelectedDoNotRenew] = useState(doNotRenew);

    const firstUpdate = useRef(true);

    const onContinueClick = () => {
      setPage(AC_PAGES.CHECKOUT);
    };

    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }

        setAcData({...acData, doNotRenew: selectedDoNotRenew});
    }, [selectedDoNotRenew]);


    if (!product) {
        console.error('Failed to load product...');
        return <></>;
    }

    return (
        <div>
            <GenericItem title={`${i18n.payments.plan}: ${product.name}`}
                         details={product.description}/>

            <div className={"row"}>
                <div className={'col-3'}>
                    <ToggleSwitch text={i18n.payments.doNotRenew}
                                  value={selectedDoNotRenew}
                                  onClick={() => {
                                      setSelectedDoNotRenew(val => !val);
                                  }}/>
                </div>
            </div>

            <div className={"row"}>
                <div className={"col-12"}>
                    <AcCostItem price={price}
                                payNow={payNow}
                                role={role}
                                expirationDate={expirationDate}/>
                    <div className={"flexSpaceBetween footerMargins"}>
                        <BackButton onClick={() => setPage(AC_PAGES.SPLASH)}/>
                        <GenericButton onClick={onContinueClick}
                                       text={i18n.common.continue}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AcPlanDetailsPage;